import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { VatRateForPurchaseQuery, VatRateForPurchaseQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(VatRateForPurchaseQuery)
@Wrapper(VatRateForPurchaseQueryHandlerBase)
export class VatRateForPurchaseQueryHandler {
    public constructor(
        http: Http
    ) { }
}
